<div class="media-container">
  @switch (type) {
    @case('image'){
      <img dalDefaultImg [src]="imageUrl" alt="Image"
        [ngClass]="customClass ? customClass : (applyClass ? 'image g-image-height' : '')" />
    }
    @case('audio'){
      <div class="audio-container">
        <img src="/assets/rendition.jpeg" alt="Audio Thumbnail" class="audio-thumbnail" />
        <audio #audioPlayer controls class="audio-player" [src]="safeUrl">
          Your browser does not support the audio tag.
        </audio>
      </div>
    }
    @case('video'){
      <video #videoPlayer controls>
        <!-- No type attribute: omitting lets the browser detect the MIME type
             from the blob, supporting MOV (video/quicktime) and other formats.
             A hardcoded type="video/mp4" causes browsers to reject non-MP4 blobs. -->
        <source [src]="safeUrl" />
        Your browser does not support the video tag.
      </video>
    }
    @case('application'){
      <img dalDefaultImg [src]="imageUrl" alt="Image"
        [ngClass]="customClass ? customClass : (applyClass ? 'image g-image-height' : '')" />
    }
    @default{
      <div>Unsupported media type</div>
    }
  }
</div>
